import { DossierStatus } from '@/components/Patient/DossierStatusIndicator';

export interface PatientStatusData {
  isArchived?: boolean | null;
  oeils?: Array<{
    choixes?: Array<{
      final?: boolean | null;
    }>;
  }>;
}

/**
 * Calcule le statut du dossier patient
 * GRIS: Archivé
 * VERT: Finalisé (a des choix finaux)
 * ORANGE: En cours
 */
export function getPatientDossierStatus(patient: PatientStatusData): DossierStatus {
  // Si le patient est archivé
  if (patient.isArchived === true) {
    return 'GRIS';
  }

  // Vérifier si le patient a des choix finaux
  const hasChoixFinal = patient.oeils?.some(oeil => 
    oeil.choixes?.some(choix => choix.final === true)
  );

  if (hasChoixFinal) {
    return 'VERT';
  }

  // Sinon, le dossier est en cours
  return 'ORANGE';
}

/**
 * Filtre les patients par statut
 */
export function filterPatientsByStatus<T extends PatientStatusData>(
  patients: T[],
  allowedStatuses: DossierStatus[]
): T[] {
  if (allowedStatuses.length === 0) {
    return patients;
  }

  return patients.filter(patient => {
    const status = getPatientDossierStatus(patient);
    return allowedStatuses.includes(status);
  });
}